import { isRecordUnknown } from '@/utils/typeGuards'
import type { PreloadableByIds } from '@/services/preloaders/types'

export const isPreloadableByIds = (service: unknown): service is PreloadableByIds => {
  if (!isRecordUnknown(service)) return false

  return 'preloadByIds' in service && 'isFailedByIds' in service
}
